module.exports = __webpack_public_path__ + "img/wallet_credit_card.00f8c815.svg";